import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AuditoriaContrato } from '../domain/auditoria-contrato.model';

export class AuditoriaContratoSerializer extends DomainSerializer<AuditoriaContrato> {}
